import React from 'react';
import Chart from 'components/pure/charts/custom/Chart';
import Guideline from 'components/pure/charts/custom/Guideline';
import Axis from 'components/pure/charts/custom/Axis';
import times from 'lodash/times';
import BarSeries from 'components/pure/charts/custom/BarSeries';
import moment from 'moment';
import seededRandomGenerator from 'utils/seededRandomGenerator';
import {scaleLinear, scaleTime} from 'd3-scale';

// use a seeded generator so the result will look the same on re-renders
const random = seededRandomGenerator();

const AverageChart = ({value: yvalue, equality, period, averageOption}) => {
  const values = times(12).map(i => random(i) * yvalue * 2);
  const average = values.reduce((sum, v) => sum + v, 0) / values.length;
  const delta = average - yvalue;
  const chartData = values.map((value, i) => ({
    date: moment().add(i, 'day'),
    // adjust the values so they will match the average
    value: Math.max(0, value - delta),
  }));
  const ymax = Math.max(...chartData.map(d => d.value)) * 1.25;

  const margins = {left: 35, right: 0, top: 0, bottom: 5};
  const svgDimensions = {width: 275, height: 200};
  const xMax = chartData[chartData.length - 1].date.clone().add(1, 'day').toDate();
  const xScale = scaleTime()
    .domain([chartData[0].date.toDate(), xMax])
    .range([margins.left, svgDimensions.width - margins.right]);

  const yScale = scaleLinear()
    .domain([0, ymax])
    .range([svgDimensions.height - margins.bottom, margins.top]);

  const scales = {xScale, yScale};
  return (
    <div className="chart-container average-chart">
      <div className="chart-title">
        Average per {averageOption || 'week'} is {equality || 'More than'} {yvalue || 10}
      </div>
      <Chart
        svgDimensions={svgDimensions}
        margins={margins}
        bordered={true}
        className="average-chart">
        <BarSeries
          className="bars"
          data={chartData}
          scales={scales}
          fill={'#55687D'}
          barWidth={19}
          roundingX={10}
          roundingY={10}
          showTooltips={false}
        />
        <Guideline
          scales={scales}
          goal={yvalue}
          baseline={yvalue}
          xMin={chartData[0].date}
          xMax={xMax}
        />
        <Axis
          orient="Bottom"
          scale={scales.xScale}
          translate={`translate(0, ${scales.yScale.range()[0]})`}
          tickSize={-5}
          ticks={9}
        />
        <Axis
          orient="Left"
          scale={scales.yScale}
          translate={`translate(${margins.left}, 0)`}
          tickSize={-5}
          ticks={2}
          tickFormat={s => s}
          tickValues={[0, yvalue]}
        />
      </Chart>
      <div className="chart-period">
        {period || '3 Months'}
        <div className="period-arrow-container">
          <div className="arrow-shaft" />
          <div className="arrow-head" />
        </div>
      </div>
    </div>
  );
};

export default AverageChart;
